import { CSSProperties } from "theme-ui"

export const components = {
  typography: {
    pb: 4,
    flexDirection: "column" as CSSProperties["flexDirection"]
  },
  swatch: {
    borderRadius: "8px",
  }
}
